import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgControlIgnition = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22.2499C17.5228 22.2499 22 17.7727 22 12.2499C22 6.72703 17.5228 2.24988 12 2.24988C6.47715 2.24988 2 6.72703 2 12.2499C2 17.7727 6.47715 22.2499 12 22.2499Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22.2499C17.5228 22.2499 22 17.7728 22 12.2499C22 6.72706 17.5228 2.24991 12 2.24991C6.47715 2.24991 2 6.72706 2 12.2499C2 17.7728 6.47715 22.2499 12 22.2499Z",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0019 19.9491C16.2541 19.9491 19.7011 16.5021 19.7011 12.2499C19.7011 7.99774 16.2541 4.55069 12.0019 4.55069C7.74979 4.55069 4.30273 7.99774 4.30273 12.2499C4.30273 16.5021 7.74979 19.9491 12.0019 19.9491Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0019 19.9491C16.2541 19.9491 19.7011 16.5021 19.7011 12.2499C19.7011 7.99777 16.2541 4.55072 12.0019 4.55072C7.74979 4.55072 4.30273 7.99777 4.30273 12.2499C4.30273 16.5021 7.74979 19.9491 12.0019 19.9491Z",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5459 10.1055C15.0492 10.6089 15.392 11.2504 15.5308 11.9486C15.6696 12.6469 15.5982 13.3706 15.3257 14.0283C15.0532 14.686 14.5919 15.2481 13.9999 15.6436C13.408 16.0391 12.712 16.2502 12.0001 16.2502C11.2882 16.2502 10.5923 16.0391 10.0003 15.6436C9.40839 15.2481 8.94701 14.686 8.67452 14.0283C8.40203 13.3706 8.33067 12.6469 8.46947 11.9486C8.60828 11.2504 8.951 10.6089 9.45431 10.1055",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.002 8.2496V12.2493",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgControlIgnition);
export { ForwardRef as ReactComponent };
